<template lang="pug">
  b-modal#modal-scrollable(
    v-model="show",
    size="md",
    header-class="lmm-common-popup-header",
    :header-bg-variant="dialog.headerBgVariant",
    :header-text-variant="dialog.headerTextVariant",
    :body-bg-variant="dialog.bodyBgVariant",
    :body-text-variant="dialog.bodyTextVariant",
    :footer-bg-variant="dialog.footerBgVariant",
    :footer-text-variant="dialog.footerTextVariant",
    no-close-on-backdrop
    scrollable)
    template(slot="modal-header")
      img(src="../../assets/admin_main_log.svg" style="height: 20px")
    //- b-container(fluid)
    //-   h5 Google OTP를 이용한 2단계 인증설정
    //-   section.help-section
    //-     h6 1. 2단계 인증(OTP)를 활성화
    //-     p
    //-       |활성화 버튼을 클릭하여 녹색으로 활성화 시킵니다.<br>
    //-       |OTP 재설정 버튼을 클릭합니다.
    //-       img(:src="`${AppState.Path.image}/otp_active.jpg`")
    //-   section.help-section
    //-     h6 2. Google Play Store, 애플 App Store에서 "Google OTP"를 설치합니다.
    //-   section.help-section
    //-     h6 3. Google OTP를 실행합니다.
    //-   section.help-section
    //-     h6 4. 링크미마인 관리자 로그아웃 후 다시 로그인 시도를 하면 Google OTP 등록창이 나타납니다.
    //-   section.help-section
    //-     h6 5. Google OTP 앱에서 바코드 스캔을 선택하여 등록합니다.
    //-   section.help-section
    //-     h6 6. 인증번호 6자리를 입력 후 로그인합니다.
    b-container(fluid)
      div.context(v-html="$t(dialog.context.path, dialog.context.args, {v: 'DESKTOP-DMTO1NP'})", :style="{'text-align': dialog.align}")
    template(slot="modal-footer")
      b-button.float-right(
        variant="primary"
        @click="close"
      ) {{$t('submit')}}
</template>

<script>
import _ from 'lodash'

const defaultValues = {
  size: 'lg',
  title: '',
  context: '',
  headerBgVariant: 'light',
  headerTextVariant: 'dark',
  bodyBgVariant: 'light',
  bodyTextVariant: 'dark',
  footerBgVariant: 'light',
  footerTextVariant: 'dark',
  align: 'left'
}
export default {
  name: 'helpOTP-dialog',
  methods: {
    close () {
      this.show = false
    }
  },
  created () {
    this.dialog = defaultValues
    this.AppState.$on('show-helpOTP-dialog', data => {
      this.dialog = _.assign(this.dialog, data)
      this.show = true
    })
  },
  data () {
    return {
      show: false,
      dialog: {}
    }
  }
}
</script>

<style lang="scss" scoped src="./dialogs.scss"></style>
